// Utilities
import { createSimpleFunctional } from '@/util'

export const VListImg = createSimpleFunctional('v-list-img')

export type VListImg = InstanceType<typeof VListImg>
